<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Histórico de Contribuições
    </h1>
</header>
<main class="main__content">
    <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formGroup"
        (ngSubmit)="getFilter()">
        <section class="content-form">
            <div class="row">
                <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Data inicio</label>
                    <input type="date" class="form-control input-form" formControlName="initialDate"
                        placeholder="DD-MM-YYYY" max="{{today | date:'yyyy-MM-dd'}}">
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('initialDate')?.touched && formGroup.get('initialDate')?.invalid">
                        O campo Data inicio está inválido!
                    </small>
                </div>
                <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Data fim</label>
                    <input type="date" class="form-control input-form" formControlName="finalDate"
                        placeholder="DD-MM-YYYY" max="{{today | date:'yyyy-MM-dd'}}">
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('finalDate')?.touched && formGroup.get('finalDate')?.invalid">
                        O campo Data Término está inválido!
                    </small>
                </div>
            </div>
        </section>
        <button [disabled]="this.loading"
            class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit">
            <div class="d-flex" *ngIf="loading; else showSpan" [@fadeIn]>
                <span>Consultando</span>
            </div>
            <ng-template #showSpan>
                <span [@fadeIn]>Consultar</span>
            </ng-template>
        </button>
    </form>

    <ng-container #showLoading>
        <spinner [show]="loading"></spinner>
      </ng-container>

    <div *ngIf="myContributionRequests">
        <div class="content_download_pdf">
            <div>
                <h3 class="content_download_pdf_title">
                    Exportar
                </h3>
            </div>
            <section class="d-flex">
                <button [disabled]="this.loading">
                    <div class="d-flex" *ngIf="loadingCsv; else showLoadingCsv">
                        <span class="spinner-button-export">
                        </span>
                    </div>
                    <ng-template #showLoadingCsv>
                        <fa-icon [icon]="faExcel" (click)="printCsv()"></fa-icon>
                    </ng-template>
                </button>
            </section>
        </div>
        <header class="content__header">
            <h3>Contribuições</h3>
            <filtro-dados [pageItens]="5" [totalItens]="myContributionRequests.totalFiltered"
                (changeQuantidade)="onChangeQuantidadeItens($event)">
            </filtro-dados>
        </header>
        <main>
            <section class="content__header__table">
                <div class="col-xl-2">Data do Pagamento</div>
                <div class="col-xl-3 display-sm-none">Contribuição Normal</div>
                <div class="col-xl-2">Contribuição Facultativa</div>
                <div class="col-xl-2">Custo Administrativo</div>
                <div class="col-xl-2 display-sm-none">Valor Pago</div>
                <div class="col-xl-1">Ações</div>
            </section>
            <section class="content__main__table mt-1">
                <section class="table__card col-12 row" *ngFor="let item of myContributionRequests.items; index as i">
                    <div class="col-xl-2 col-sm-2 px-2  px-md-3">
                        <span>
                            {{ item.paymentDate | date:'dd/MM/yyyy' }}
                        </span>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 px-2 pl-md-3 display-sm-none">
                        <span>
                            {{ item.normalContribution | currency:'BRL':'symbol':'1.2-2':'pt' }}
                        </span>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-sm-2 px-2 pl-md-3">
                        <span>
                            {{ item.extraContribution | currency:'BRL':'symbol':'1.2-2':'pt' }}
                        </span>
                    </div>
                    <div class="col-xl-2 col-sm-2 px-2 pl-md-3">
                        <span> {{ item.administrativeCost | currency:'BRL':'symbol':'1.2-2':'pt' }}
                        </span>
                    </div>
                    <div class="col-xl-2 col-sm-2 px-2 pl-md-3 display-sm-none">
                        <span>
                            {{ item.total | currency:'BRL':'symbol':'1.2-2':'pt'}}
                        </span>
                    </div>
                    <div class="col-1">
                        <a (click)="visualizarContribuicao(item)">
                            <fa-icon class="fa-icon icon-eye" [icon]="faEye"></fa-icon>
                        </a>
                    </div>
                </section>
            </section>
        </main>
        <footer>
            <paginacao [currentPage]="1" [collectionSize]="myContributionRequests.totalFiltered"
                [pageSize]="formGroup.value.itemsPerPage" (changeNumber)="onChangePagination($event)">
            </paginacao>
        </footer>
    </div>
</main>